const EphemeralTicketId = {
    New: -1, // the custom field has not been locked in yet
    Staging: -2, // the custom field is locked in but not persisted yet
};

export { EphemeralTicketId };
